import { Application } from "@hotwired/stimulus"
import { AssistantVoiceSampleController } from "./controllers/assistant-voice-sample-controller";

declare global {
    interface Window {
        Stimulus: Application;
    }
}

// Start Stimulus
window.Stimulus = Application.start();
window.Stimulus.debug = false; // Set to true to get verbose logging of Stimulus events.

// Auth-local controllers
window.Stimulus.register("assistant-voice-sample", AssistantVoiceSampleController);
